// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-box[data-v-ca23364c] {\n  text-align: right;\n}\n.error-color[data-v-ca23364c] {\n  color: red !important;\n}", ""]);
// Exports
module.exports = exports;
